export default "__VITE_ASSET__6f5394d1__"